import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, throwError, of } from 'rxjs' //'rxjs/dist/types/internal/Observable';
import { map, catchError } from 'rxjs/operators'
import { SurveyService } from './surveyService';
import { HttpErrorResponse } from '@angular/common/http'
import { ApplicationStorage } from './applicationStorage';


@Injectable()
export class SurveyGuardService implements CanActivate {

    constructor(public surveyService: SurveyService, private router: Router,
        private applicationStorage: ApplicationStorage) {
    }


    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        let surveyId = route.paramMap.get('surveyId');

        if (surveyId) {
            localStorage.setItem('surveyId', surveyId);
        }
        // return of(true); //TODO remove after testing
        return this.surveyService.getSurvey(surveyId || '')
            .pipe(
                map((data: any): boolean => {
                    localStorage.setItem("surveyType", data?.surveyType)

                    if (data.error === true) {
                        this.router.navigate(['error'])
                    }
                    if (!data.error) {
                        this.applicationStorage.storage.set("surveyType", data.surveyType);
                        this.applicationStorage.storage.set("surveyUnsubscribeLink", data.surveyUnsubscribeLink);
                        this.applicationStorage.storage.set("surveyConsumerAgreement", data.surveyConsumerAgreement);
                        this.applicationStorage.storage.set("surveyOutroText", data.surveyOutroText);
                        this.applicationStorage.storage.set("surveyIntroText", data.surveyIntroText);
                        localStorage.setItem("surveyType", data.surveyType)
                        localStorage.setItem("surveyOutroText", data.surveyOutroText);



                    }
                    return !data.error
                }),
                catchError((error: any): Observable<boolean> => {
                    if (error.error instanceof ErrorEvent) {
                        console.error('A client error occurred:', error.error.message);
                    } else {
                        console.error(`Backend returned code ${error.status}, body was: ${error.message}`);
                    }
                    this.router.navigate(['error'])
                    return of(false);
                })
            );
    }

}